import { render, staticRenderFns } from "./ObjectDetail.vue?vue&type=template&id=7711c7a9&scoped=true"
import script from "./ObjectDetail.vue?vue&type=script&lang=js"
export * from "./ObjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ObjectDetail.vue?vue&type=style&index=0&id=7711c7a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7711c7a9",
  null
  
)

export default component.exports